import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { useSingleCache } from '@/data/hook/query/v2/useCacheManager';
import { examQueries } from '@/data/query-keys/examQueryKey';
import Exam from '@/models/Exam';

const useExamWorkspace = () => {
  const {
    courseLineId: courseLineParam,
    moduleId: moduleParam,
    slug,
    examId: examParam,
  } = useParams();

  const isNew = examParam === 'new';
  const courseLineId = Number(courseLineParam);
  const moduleId = Number(moduleParam);
  const examId = Number(examParam);

  const queryKey = examQueries.get(examId);

  const { data: exam, isInitialLoading } = useQuery({
    ...queryKey,
    enabled: !!slug && !isNew && !!examId,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache<Exam>(queryKey.queryKey);

  const isLoading = isInitialLoading && !isNew && !!examId;

  return {
    exam,
    cache,
    slug,
    courseLineId,
    moduleId,
    examId,
    isLoading,
  };
};

export default useExamWorkspace;
